<div class="grid-x">
    <div class="cell">
        Maximum number of days into the past the date picker will allow:
    </div>
    <div class="cell">
        <input type="number" step="1" min="0" [(ngModel)]="componentData.config.maxDaysPast" />
    </div>
    <div class="cell">
        Maximum number of days into the future the date picker will allow:
    </div>
    <div class="cell">
        <input type="number" step="1" min="0" [(ngModel)]="componentData.config.maxDaysFuture" />
    </div>
</div>